import { render } from "./VabeneAddCustomerPage.vue?vue&type=template&id=7f1e0a82&ts=true"
import script from "./VabeneAddCustomerPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__